const SettingsMenuTypes = (that = {}) => {
    return [
        {
            enabled: true,
            key: "notifications",
            label: that.$t ? that.$t(`settings.notifications`) : "Notifications",
            icon: {
                type: "material-icons",
                name: "notifications",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "company",
            group: "General",
            label: that.$t ? that.$t(`settings.company`) : "Company",
            icon: {
                type: "material-icons",
                name: "apartment",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "features",
            group: "General",
            label: that.$t ? that.$t(`settings.features`) : "Features",
            icon: {
                type: "material-icons",
                name: "settings",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "language",
            group: "General",
            label: that.$t ? that.$t(`settings.languageTimeZone`) : "Language",
            icon: {
                type: "material-icons",
                name: "translate",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "wallet",
            group: "General",
            label: that.$t ? that.$t(`settings.wallet`) : "Wallet",
            icon: {
                type: "material-icons",
                name: "wallet",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "audit-logs",
            group: "General",
            label: that.$t ? that.$t(`settings.auditlogs`) : "Audit Logs",
            icon: {
                type: "material-icons",
                name: "storage",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "bubble-settings",
            group: "Chat",
            label: that.$t ? that.$t(`settings.bubble-settings`) : "Bubble Settings",
            icon: {
                type: "material-icons",
                name: "chat_bubble",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "bubble-actions",
            group: "Chat",
            label: that.$t ? that.$t(`settings.bubble-actions`) : "Bubble Actions",
            icon: {
                type: "material-icons",
                name: "build",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "theme-settings",
            group: "Chat",
            label: that.$t ? that.$t(`settings.theme-settings`) : "Theme Settings",
            icon: {
                type: "material-icons",
                name: "settings",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "visitor-login-form",
            group: "Chat",
            label: that.$t ? that.$t(`settings.visitorLoginForm`) : "Visitor Login Form",
            icon: {
                type: "material-icons",
                name: "check_box",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "visitor-attribute",
            group: "Chat",
            label: that.$t ? that.$t(`settings.visitorAttribute`) : "Visitor Attribute",
            icon: {
                type: "material-icons",
                name: "edit_note",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "auto-assign",
            group: "Chat",
            label: that.$t ? that.$t(`settings.auto_assign`) : "Auto Assign",
            icon: {
                type: "material-icons",
                name: "settings_accessibility",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "timings-settings",
            group: "Timings",
            label: that.$t ? that.$t(`settings.timing_settings`) : "Timings Settings",
            icon: {
                type: "material-icons",
                name: "hourglass_empty",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "availability",
            group: "Timings",
            label: that.$t ? that.$t(`settings.availability`) : "Availability",
            icon: {
                type: "material-icons",
                name: "calendar_month",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "website-integration",
            group: "Integration",
            label: that.$t ? that.$t(`settings.website-integration`) : "WebSite Integration",
            icon: {
                type: "material-icons",
                name: "integration_instructions",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "developer",
            group: "Integration",
            label: that.$t ? that.$t(`settings.developer`) : "Developer",
            icon: {
                type: "material-icons",
                name: "developer_mode",
            },
        },
    ];
};
export default SettingsMenuTypes;
